
export enum AmpEventSourceTypeRecruiter {
  RECRUITER = 'RECRUITER',
  REACHOUT = 'RECRUITER_REACHOUT'
}
